import PropTypes from "prop-types"
import React from "react"

import Badge from "src/components/Badge"

const formatDate = (value) => {
  if (!value) return "—"
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return "—"
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  })
}

const CurrentPlanPanel = ({ subscription }) => {
  if (!subscription) {
    return (
      <section className="rounded border border-gray-200 bg-white px-5 pb-5 pt-2">
        <h2 className="mb-2 text-lg font-semibold">Current plan</h2>
        <p className="text-gray-600">No active subscription.</p>
      </section>
    )
  }

  const modules = subscription.modules || []

  const endLabel = (() => {
    if (!subscription.end_date) return "Next invoice"
    return new Date(subscription.end_date) < new Date() ? "Ended" : "Ends"
  })()

  return (
    <section className="rounded border border-gray-200 bg-white px-5 pb-5 pt-2">
      <h2 className="mb-3 text-lg font-semibold">Current plan</h2>
      <dl className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <dt className="text-xs uppercase text-gray-500">Status</dt>
          <dd className="text-gray-900">{subscription.status || "—"}</dd>
        </div>
        <div>
          <dt className="text-xs uppercase text-gray-500">Renews</dt>
          <dd className="text-gray-900">
            {subscription.auto_renews
              ? formatDate(subscription.renewal_date)
              : "Does not auto renew"}
          </dd>
        </div>
        <div>
          <dt className="text-xs uppercase text-gray-500">Started</dt>
          <dd className="text-gray-900">
            {formatDate(subscription.start_date)}
          </dd>
        </div>
        <div>
          <dt className="text-xs uppercase text-gray-500">{endLabel}</dt>
          <dd className="text-gray-900">
            {formatDate(
              subscription.end_date || subscription.next_invoice_date
            )}
          </dd>
        </div>
      </dl>
      {modules.length > 0 && (
        <div className="mt-6">
          <div className="mb-2 text-xs uppercase text-gray-500">Modules</div>
          <div className="flex flex-wrap gap-2">
            {modules.map((m) => (
              <Badge key={m} text={m} color="gray" variant="small" />
            ))}
          </div>
        </div>
      )}
    </section>
  )
}

CurrentPlanPanel.propTypes = {
  subscription: PropTypes.shape({
    id: PropTypes.string,
    modules: PropTypes.arrayOf(PropTypes.string),
    status: PropTypes.string,
    auto_renews: PropTypes.bool,
    renewal_date: PropTypes.string,
    next_invoice_date: PropTypes.string,
    start_date: PropTypes.string,
    end_date: PropTypes.string,
  }),
}

export default CurrentPlanPanel
